import i18n from "./i18n";

// medzera - velke znaky anglickej abecedy - male znaky anglickej abecedy
const objABC_en__A_a = {
    // postupnost znakov triedenia (len informativne)
    info: 'space,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z',

    // kontinualne pole znakov triedenia (vsetky znaky mimo tohto pola budu zotriedene za danou postupnostou)
    chars: [
        ' ',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    ],

    // zahrnut do triedenia specialne znaky (napr. dz, dž, ch)
    spec: false,

    // rozlisovat velke a male pismena
    upper_lower: true,
};
// medzera - cislice - velke a male znaky abecedy striedavo
const objABC_sk_cz__0Aa = {
    // postupnost znakov triedenia (len informativne)
    info: 'space,0,1,2,3,4,5,6,7,8,9,A,a,Á,á,Ä,ä,B,b,C,c,Č,č,D,d,Ď,ď,Dz,dz,DZ,dZ,Dž,dž,DŽ,dŽ,E,e,É,é,Ě,ě,F,f,G,g,H,h,Ch,ch,CH,cH,I,i,Í,í,J,j,K,k,L,l,Ĺ,ĺ,Ľ,ľ,M,m,N,n,Ň,ň,O,o,Ó,ó,Ô,ô,Ö,ö,Ő,ő,P,p,Q,q,R,r,Ŕ,ŕ,Ř,ř,S,s,Š,š,T,t,Ť,ť,U,u,Ú,ú,Ů,ů,Ü,ü,Ű,ű,V,v,W,w,X,x,Y,y,Ý,ý,Z,z,Ž,ž',

    // kontinualne pole znakov triedenia (vsetky znaky mimo tohto pola budu zotriedene za danou postupnostou)
    chars: [
        ' ',
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'A', 'a', 'Á', 'á', 'Ä', 'ä', 'B', 'b', 'C', 'c', 'Č', 'č', 'D', 'd', 'Ď', 'ď', 'Dz', 'dz', 'DZ', 'dZ', 'Dž', 'dž', 'DŽ', 'dŽ', 'E', 'e', 'É', 'é', 'Ě', 'ě', 'F', 'f', 'G', 'g', 'H', 'h', 'Ch', 'ch', 'CH', 'cH', 'I', 'i', 'Í', 'í', 'J', 'j', 'K', 'k', 'L', 'l', 'Ĺ', 'ĺ', 'Ľ', 'ľ', 'M', 'm', 'N', 'n', 'Ň', 'ň', 'O', 'o', 'Ó', 'ó', 'Ô', 'ô', 'Ö', 'ö', 'Ő', 'ő', 'P', 'p', 'Q', 'q', 'R', 'r', 'Ŕ', 'ŕ', 'Ř', 'ř', 'S', 's', 'Š', 'š', 'T', 't', 'Ť', 'ť', 'U', 'u', 'Ú', 'ú', 'Ů', 'ů', 'Ü', 'ü', 'Ű', 'ű', 'V', 'v', 'W', 'w', 'X', 'x', 'Y', 'y', 'Ý', 'ý', 'Z', 'z', 'Ž', 'ž',
    ],

    // zahrnut do triedenia specialne znaky (napr. dz, dž, ch)
    spec: true,

    // rozlisovat velke a male pismena
    upper_lower: true,
};

let objABC = {};

// definovanie volitelnej specifikacie triedenia zo suboru 'alphabet.js'
// *************************************************************************************************************************
// objABC = objABC_sk_cz__0Aa;          // 1 (medzera - cislice - velke a male znaky abecedy striedavo)
// objABC = objABC_sk_cz__0aA;          // 2 (medzera - cislice - male a velke znaky abecedy striedavo)
// objABC = objABC_sk_cz__0A_a;         // 3 (medzera - cislice - velke znaky abecedy - male znaky abecedy)
// objABC = objABC_sk_cz__0a_A;         // 4 (medzera - cislice - male znaky abecedy - velke znaky abecedy)
// objABC = objABC_en__A_a;             // 5 (medzera - velke znaky anglickej abecedy - male znaky anglickej abecedy)
// objABC = objABC__ASCII;              // 6 (ASCII)
// objABC = objABC_sk_cz__Any;          // 7 (medzera - pomlcka - vlastne cislice - vlastne znaky abecedy :)
// *************************************************************************************************************************

let sizeChars = 0;

let str_c1_sk_cz = "cC", str_c2_sk_cz = "hH";
let str_d1_sk_cz = "dD", str_d2_sk_cz = "zZžŽ";

let i = 0;
let j = 0;
let size_a, size_b;
let char_a, char_b;
let code_a, code_b;

function setupAlphabet() {
    switch (i18n.locale) {
        case "en":
            objABC = objABC_en__A_a;
            break;
        case "cz":
            objABC = objABC_sk_cz__0Aa;
            break;
        default:
            objABC = objABC_en__A_a;
    }

    objABC.alphabet = {};

    sizeChars = objABC.chars.length;
    for (let i = 0; i < sizeChars; i++) {
        objABC.alphabet[objABC.chars[i]] = i + 1;
    }
}

function sortData(a, b, way) {
    way = way || 1; // (way = 1) = ascending (vzostupne) A-Z [default],    (way = -1) = descending (zostupne) Z-A

    if (!objABC.upper_lower) {
        a = a.toUpperCase();
        b = b.toUpperCase();
    }

    if (a === b) return 0;

    i = 0;
    j = 0;

    size_a = a.length;
    size_b = b.length;

    while (i < size_a && j < size_b) {
        char_a = a[i];
        if (objABC.spec) {
            if (str_c1_sk_cz.indexOf(a[i]) >= 0) { // ch
                if ((i < size_a - 1) && (str_c2_sk_cz.indexOf(a[i + 1]) >= 0)) {
                    char_a = a[i].concat(a[i + 1]);
                    i++;
                }
            }
            else if (str_d1_sk_cz.indexOf(a[i]) >= 0) { // dz, dž
                if ((i < size_a - 1) && (str_d2_sk_cz.indexOf(a[i + 1]) >= 0)) {
                    char_a = a[i].concat(a[i + 1]);
                    i++;
                }
            }
        }
        code_a = objABC.alphabet[char_a];

        char_b = b[j];
        if (objABC.spec) {
            if (str_c1_sk_cz.indexOf(b[j]) >= 0) { // ch
                if ((j < size_b - 1) && (str_c2_sk_cz.indexOf(b[j + 1]) >= 0)) {
                    char_b = b[j].concat(b[j + 1]);
                    j++;
                }
            }
            else if (str_d1_sk_cz.indexOf(b[j]) >= 0) { // dz, dž
                if ((j < size_b - 1) && (str_d2_sk_cz.indexOf(b[j + 1]) >= 0)) {
                    char_b = b[j].concat(b[j + 1]);
                    j++;
                }
            }
        }
        code_b = objABC.alphabet[char_b];

        code_a = (code_a) ? code_a : char_a.charCodeAt(0) + sizeChars;
        code_b = (code_b) ? code_b : char_b.charCodeAt(0) + sizeChars;

        if (code_a !== code_b) break;
        i++;
        j++;
    }

    if (i === size_a) return -way;
    if (j === size_b) return way;

    return code_a * way - code_b * way;
}

export default function (arr){
    setupAlphabet();
    let lowerCaseArr = [...arr].filter((element)=>{return element !== undefined}).map(el=>el.toLowerCase());
    let sorted = [...lowerCaseArr].sort(function (a, b) {
        return sortData(a, b, 1); // 1 = ascending
    });
    return sorted.map(el=>arr[lowerCaseArr.indexOf(el)])
}


